import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 40" fill="currentColor" {...this.props}><path className="st0" d="M1.9 0L0 1.9v6.3l4 3.7 4-3.7V0zM0 29.9v6.3l4 3.7 4-3.7V28H1.9zM3 13v3H2l-1 1v4.7l2 1.7V27h2v-3.6l2-1.7V16H5v-3z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/route.inline.svg